import { Button, Icon, Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { SaveColumnsButtonProps } from './SaveColumnsButtonProps';
import SaveIcon from '@mui/icons-material/Save';
import useTranslation from '../../hooks/useTranslation';

const SaveColumnsButton: FC<SaveColumnsButtonProps> = ({
  style,
  handleStorage,
}) => {
  const t = useTranslation();
  return (
    <Tooltip title={t('tooltips.saveColumns')}>
      <Button style={style} onClick={handleStorage}>
        <Icon sx={{ height: 'unset', width: 'unset', marginRight: '8px' }}>
          <SaveIcon sx={{ fontSize: 'large' }} />
        </Icon>
        <span>{t('common.saveColumns')}</span>
      </Button>
    </Tooltip>
  );
};

export default SaveColumnsButton;
